export const CAMPAIGN_GRID_TEMPLATES = {
  /**
   * Used when CampaignInfo needs to visually align with OrderItemCard
   *
   * CampaignInfo layout:
   * ┌────────────┬────────┬────────┬────────────┬────────────┬────────────┐
   * │  Campaign  │ Start  │  End   │ Impressions│   Budget   │  Actions   │
   * │   12fr     │  2fr   │  2fr   │    4fr     │    3fr     │    4fr     │
   * └────────────┴────────┴────────┴────────────┴────────────┴────────────┘
   *
   */
  aligned: 'grid min-w-max grid-cols-[10fr_2fr_2fr_4fr_3fr_3fr] items-center gap-x-4',
  /**
   * Used in smaller width contexts like modals
   */
  compact: 'grid grid-cols-[4fr_1fr_1fr_2fr_1fr_20px] items-center gap-x-4',
} as const

export type CampaignLayout = keyof typeof CAMPAIGN_GRID_TEMPLATES

// @note - default start time is 6 minutes from now to avoid 'must be at least 6 minutes in the future' error
export const DEFAULT_START_TIME = '12:00 AM'
export const DEFAULT_END_TIME = '11:59 PM'

export const DEFAULT_GOAL_VALUE = 0.04

export const DATE_FORMATS = {
  /** Format used for host app communication: "12/25/2023 12:00 PM" */
  HOST_APP_DATETIME: 'M/d/yyyy',
  /** Format used for date-only display */
  DISPLAY_DATE_SHORT: 'MM/dd/yy',
  /** Format used for full date display */
  DISPLAY_DATE_FULL: 'MM/DD/YYYY',
  /** Format used for time input/display */
  TIME_DISPLAY: 'hh:mm A',
} as const
